import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSnapshot } from "valtio";
import { QUERY_KEYS } from "@config/constant";
import { OspApiClientContext } from "@features/api/client/OspApiClientProvider";
import { rootStore } from "@store/rootStore";

export const useMemberRetentionStats = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { memberApi } = useContext(OspApiClientContext);
  const { ownerInfo } = useSnapshot(rootStore.user);

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.MEMBER_RETENTION_STATS, ownerInfo?.id],
    enabled: enabled && !!memberApi && !!ownerInfo?.id,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const res = await memberApi?.members?.getMemberRetentionStats();
      return res?.data?.data;
    },
  });

  return {
    data,
    ...rest,
  };
};
